module.exports = __webpack_public_path__ + "static/media/suite-logo-white.892021e7.png";